// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LngcT4ex5LbkMg {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 20px var(--ds-space-0, 0);
}
.d2jPI1LVrx6akE {
  position: relative;
  margin-right: var(--ds-space-200, 16px);
}
.YAfarBpuOkf9NJ {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.YAfarBpuOkf9NJ .GxX8JLMG4SGAvQ {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 10px;
  margin-bottom: var(--ds-space-0, 0);
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 24px;
}
.YAfarBpuOkf9NJ .M7DuYRS8ksp5f8 {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeHeader": `LngcT4ex5LbkMg`,
	"avatar": `d2jPI1LVrx6akE`,
	"details": `YAfarBpuOkf9NJ`,
	"name": `GxX8JLMG4SGAvQ`,
	"username": `M7DuYRS8ksp5f8`
};
export default ___CSS_LOADER_EXPORT___;
